import { NextRouter } from 'next/router';

import { IFacetOption } from 'shared/types/ConstructorFacet';

/**
 * [getFiltersQuery] builds the query object for Link's href query value
 * @param routerQuery - query from useRouter
 * @param facetType - name of the facet we're filtering by
 * @param option - option object from constructor
 */

export const getFiltersQuery = (
  routerQuery: NextRouter['query'],
  facetType: string,
  option: IFacetOption,
) => {
  const queryObject = { ...routerQuery };
  const existingFacetTypes = Object.keys(queryObject);
  const existingFilterValues = queryObject[facetType];
  const filterValue = option.value;

  if (existingFacetTypes.includes(facetType)) {
    // if facet type exists in queryObject, and filterValue is already selected, remove it to deselect it
    // existingFilterValues can be a string if only 1 selected, or an array if multiple selected
    if (
      Array.isArray(existingFilterValues)
        ? existingFilterValues.includes(filterValue)
        : existingFilterValues === filterValue
    ) {
      if (Array.isArray(existingFilterValues)) {
        // remove the filterValue from the array
        queryObject[facetType] = existingFilterValues.filter((val) => val !== filterValue);
      } else {
        // remove the facet type since there was only 1 selected
        delete queryObject[facetType];
      }
    } else {
      // facet type exists in queryObject, but filterValue is not already selected, add it to select it
      queryObject[facetType] = Array.isArray(queryObject[facetType])
        ? [...queryObject[facetType], filterValue]
        : [queryObject[facetType] as string, filterValue];
    }
  } else {
    // add new facet type to queryObject
    queryObject[facetType] = filterValue;
  }

  return queryObject;
};
